import DateTimePicker from '../../components/controls/DateTimePicker/DateTimePicker';
import FindAccount from '../../components/controls/FindAccount/FindAccount';
import FormCommand from '../../components/controls/FormCommand/FormCommand';
import classes from './account-statement.module.css';

export interface AccountStatementProps { }

export const AccountStatement = (props: AccountStatementProps) => {

	return (
		<div className='row'>
			<div className="col">
				<FindAccount id='account' text='Select Account' />
				<div className="row">
					<div className="col-6">
						<DateTimePicker id='startDate' text='Start Date' type='date' />
					</div>
					<div className="col-6">
						<DateTimePicker id='endDate' text='End Date' type='date' />
					</div>
				</div>

				<FormCommand commandText='Preview' />
			</div>
			<div className='col'>

			</div>
		</div>
	);
};